import styled from 'styled-components';


const LoadertWrapper = styled.div`
.loader{
    position:absolute;
    z-index:99;
    left:0;
    top:0;
    display:flex;
    align-items:center;
    justify-content:center;
    width:100%;
	height:100%;
	background:rgba(255,255,255,0.7);

    .loader-icon{
        border: 5px solid #f3f3f3;
        border-radius: 50%;
        border-top: 5px solid #344177;
        width: 50px;
        height: 50px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
      }
      
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
}

`;

export default LoadertWrapper;
